<template>
  <div>
    <div class="accordion">
      <div class="accordion__body">
        <div class="accordion__form" style="max-width: 1180px;">
          <div class="accordion__part">
            <div class="accordion__row accordion__row--5">
              <app-form-group label="National ID" label-for="national_id">
                <app-input
                  v-model="documents.national_id"
                  id="national_id"
                  placeholder="National ID"
                  name="national_id"
                />
              </app-form-group>
              <app-form-group label="National ID (Expire)">
                <app-date-picker
                  v-model="documents.national_id_expire"
                  placeholder="Specify a date"
                />
              </app-form-group>
              <app-form-group label="National ID (Scan copy)">
                <app-uploader
                  v-model="documents.national_id_scancopy"
                  :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                  formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                  class="custom-uploader--flex"
                />
              </app-form-group>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Voting card" label-for="voting_card">
                <app-input
                  v-model="documents.voting_card"
                  id="voting_card"
                  placeholder="Voting card"
                  name="voting_card"
                />
              </app-form-group>
            </div>
          </div>
          <app-cells :indent="false" position="end">
            <app-button @click.native="onSendForm" ref="submit_personal">
              Save
            </app-button>
          </app-cells>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { patchClimbingMountainCrew } from '@/http'

export default {
  name: 'ClimbingMountainCrewDocuments',
  props: {
    documents: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onSendForm() {
      this.$refs.submit_personal.preload = true
      patchClimbingMountainCrew(this.$route.params.id, this.normalizePersonal())
        .finally(() => { this.$refs.submit_personal.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
        })
    },
    normalizePersonal() {
      const normalizedForm = { ...this.documents }

      if (normalizedForm.national_id_scancopy && normalizedForm.national_id_scancopy.id) {
        normalizedForm.national_id_scancopy = normalizedForm.national_id_scancopy.id
      } else normalizedForm.national_id_scancopy = null

      return normalizedForm
    },
  }
}
</script>
